import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('admin_token') || '',
    admin: JSON.parse(localStorage.getItem('admin_info') || 'null')
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      if (token) localStorage.setItem('admin_token', token);
      else localStorage.removeItem('admin_token');
    },
    setAdmin(state, admin) {
      state.admin = admin;
      if (admin) localStorage.setItem('admin_info', JSON.stringify(admin));
      else localStorage.removeItem('admin_info');
    }
  },
  actions: {
    login({ commit }, { token, admin }) {
      commit('setToken', token);
      commit('setAdmin', admin);
    },
    logout({ commit }) {
      commit('setToken', '');
      commit('setAdmin', null);
    }
  }
});
